var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-container"},[(!_vm.errorText)?_c('div',{staticClass:"spinner"}):_vm._e(),_c('div',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.errorText || "加载中..."))])])
}
var staticRenderFns = []

export { render, staticRenderFns }